import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './TwoColumnLayout.module.less';

export default function ContentPanel({className, style, enableScroll = false, children}) {
    return (
        <div
            className={classNames(
                styles.contentPanel,
                {[styles.enableScroll]: enableScroll},
                className
            )}
            style={style}
        >
            {children}
        </div>
    );
}

ContentPanel.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    // 是否允许滚动，也就是是 overflow-y: auto
    enableScroll: PropTypes.bool,
    children: PropTypes.node,
};
